/**
 * This ugly stuff is here due to problems between mui 4.x and emotion
 * and should be gone when we switch to mui 5.x thoughout the projects
 */
export const COLOR_TEXT_PRIMARY = 'rgb(50,50,50)'
